import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";
import {
    entryFunc
} from "./pages/_entry";
import {
    strengthFunc
} from "./pages/_strength";
import {
    recruitFunc
} from "./pages/_recruit";
import {
    newsFunc
} from "./pages/_news";
import {
    membersFunc
} from "./pages/_members";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
    entryFunc();
    strengthFunc();
    recruitFunc();
    newsFunc();
    membersFunc();
});